import {
  ColumnDirective,
  ColumnsDirective,
  ContextMenu,
  Edit,
  ExcelExport,
  Filter,
  GridComponent,
  Inject,
  Page,
  PdfExport,
  Resize,
  Sort,
} from "@syncfusion/ej2-react-grids";
import React from "react";

import { Header } from "../components";
import { ordersGrid } from "../data/dummy";
import { useGetPaymentsQuery } from "../redux/paymentService";
const Orders = () => {
  const handleRowSelected = (args) => {
    console.log(args.data);
  };

  const { data, isLoading, isError } = useGetPaymentsQuery();

  console.log("les paiements", data);
  return (
    <div className="m-2 md:m-10 p-2 md: p-10 bg-white rounded-3xl">
      <Header category="Page" title="Recouvremennts" />

      <GridComponent
        id="gridcomp"
        dataSource={data?.data}
        allowPaging
        allowSorting>
        <ColumnsDirective>
          {ordersGrid.map((item, index) => (
            <ColumnDirective key={index} {...item} />
          ))}
        </ColumnsDirective>
        <Inject
          services={[
            Resize,
            Sort,
            ContextMenu,
            Filter,
            Page,
            ExcelExport,
            Edit,
            PdfExport,
          ]}
        />
      </GridComponent>
    </div>
  );
};

export default Orders;
